import React from "react";
import { Scope } from "informed";

import { Font } from "../";
import { ColorPicker, FileInput, BorderStylePicker, NumberInput, GradientInput } from "../../../../../shared/Forms";
import { renderFields } from "../helper";

const TabBar = () => {
	const fields = [
		<ColorPicker
			field="backgroundColor"
			id="backgroundColor"
			placeholder="Background Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<FileInput
			field="backgroundImageUrl"
			id="backgroundImageUrl"
			placeholder="Background Image URL"
			themeBuilderInputType="FileInput"
		/>,
		<GradientInput
			field="backgroundGradient"
			id="backgroundGradient"
			placeholder="Gradient"
			themeBuilderInputType="GradientInput"
		/>,
		<ColorPicker
			field="borderColor"
			id="borderColor"
			placeholder="Border Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<BorderStylePicker
			field="borderStyle"
			id="borderStyle"
			placeholder="Border Style"
			themeBuilderInputType="BorderStylePicker"
		/>,
		<NumberInput
			field="borderWidth"
			id="borderWidth"
			placeholder="Border Width"
			themeBuilderInputType="NumberInput"
		/>,
	];
	return (
		<div className="theme-columns">
			<div className="theme-column">
				<h4 className="header">Tab Bar</h4>
				<div className="theme-content">
					{renderFields(fields)}
					<Scope scope="text">
						<h4 className="ta-center">Text</h4>
						<Font state="navigation-tabBar" hideFieldRowBorder={true} />
					</Scope>
				</div>
			</div>
		</div>
	);
};

export default TabBar;
